import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import {
    reactive,
    onMounted,
    computed,
    ref,
  } from "vue";
  import useVuelidate from "@vuelidate/core";
  import {
    email,
    helpers,
    required,
    numeric,
    minLength,
  } from "@vuelidate/validators";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { validPhoneNumber } from "@/helpers/validation";
  import CheckboxInput from "../input/CheckboxInput.vue";
  import store from "@/store";
  import InitialHoldPurchaserTypes from "@/enums/InitialHoldPurchaserTypes";
  import lotApi from "@/services/api/lotApi";
  import { CreateInitialHoldWithPartnerInterface } from "@/types/InitialHoldInterface";
  import { UserRoles } from "@/enums/UserRoles";
  import { useToast } from "vue-toastification";
  import axios, { Axios } from "axios";
  import { HolderType } from "@/enums/InitialHoldHolderType";
  import { trackSendInitialHold } from "@/helpers/initialHold/trackSendInitialHold";
  import { StatesEnum } from "@/enums/StatesEnum";
  import { calculateStateFromPostcode } from "@/helpers/initialHold/calculateStateFromPostcode";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InitialHoldWithPartnerModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    lot: {
      required: true,
      type: Object,
    },
  },
  emits: ["send", "back", "close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const disabled = ref<boolean>(false);
  const toast = useToast();
  const emits = __emit;
  const props = __props;

  const customerIdOrNull = computed(() => {
    return store?.state?.user?.data?._id ? store.state.user.data._id : null;
  });

  const formFields = {
    purchaserFirstName: "",
    purchaserLastName: "",
    purchaserEmail: "",
    purchaserPhone: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    company: "",
    postcode: "",
    state: "",
  };

  const form = reactive(Object.assign({}, formFields));
  const rules = {
    firstName: { required },
    lastName: { required },
    phone: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phone number",
        validPhoneNumber
      ),
    },
    purchaserPhone: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phone number",
        validPhoneNumber
      ),
    },
    email: { required, email },
    company: { required },
    purchaserFirstName: { required },
    purchaserLastName: { required },
    purchaserEmail: { required, email },
    postcode: { required, numeric, minLength: minLength(4) },
  };

  const v$ = useVuelidate(rules, form);

  function onClose() {
    clearForm();
    resetVuelidateErrors(v$);
    emits("close");
  }

  async function submitForm() {
    v$.value.$touch();
    const isNoErrors = await v$.value.$validate();

    if (!isNoErrors) {
      return;
    }

    createInitialHoldRequest({
      lotId: props.lot.lotId._id,
      lotTitle: props.lot.lotId.title,
      landownerId: props.lot?.landownerId?._id ?? props.lot.lotId.landownerId,
      purchaserDetails: {
        email: form.purchaserEmail.toLowerCase(),
        firstName: form.purchaserFirstName,
        lastName: form.purchaserLastName,
        phone: form.purchaserPhone,
      },
      companyDetails: form.company,
      leadDetails: {
        email: form.email.toLowerCase(),
        firstName: form.firstName,
        lastName: form.lastName,
        phone: form.phone,
      },
      estateId: props.lot.lotId.estateId,
      ...(customerIdOrNull.value && { customerId: customerIdOrNull.value }),
      holderType: HolderType.BUILDER_OR_CHANNEL_PARTNER,
      postcode: form.postcode,
      state: calculateStateFromPostcode(form.postcode),
    });
  }

  const createInitialHoldRequest = (
    data: CreateInitialHoldWithPartnerInterface
  ) => {
    disabled.value = true;
    store
      .dispatch("initialHold/createInitialHold", data)
      .then(() => {
        emits("send");
        trackSendInitialHold(props.lot.lotId.estateId);
        onClose();
      })
      .catch(() => {
        toast.error("Something went wrong, please try again later");
      })
      .finally(() => {
        disabled.value = false;
      });
  };

  function clearForm() {
    Object.assign(form, formFields);
    resetVuelidateErrors(v$);
  }
  const onBack = () => {
    emits("back");
  };

const __returned__ = { disabled, toast, emits, props, customerIdOrNull, formFields, form, rules, v$, onClose, submitForm, createInitialHoldRequest, clearForm, onBack, Modal, reactive, onMounted, computed, ref, get useVuelidate() { return useVuelidate }, get email() { return email }, get helpers() { return helpers }, get required() { return required }, get numeric() { return numeric }, get minLength() { return minLength }, get resetVuelidateErrors() { return resetVuelidateErrors }, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get validPhoneNumber() { return validPhoneNumber }, CheckboxInput, get store() { return store }, get InitialHoldPurchaserTypes() { return InitialHoldPurchaserTypes }, get lotApi() { return lotApi }, get CreateInitialHoldWithPartnerInterface() { return CreateInitialHoldWithPartnerInterface }, get UserRoles() { return UserRoles }, get useToast() { return useToast }, get axios() { return axios }, get Axios() { return Axios }, get HolderType() { return HolderType }, get trackSendInitialHold() { return trackSendInitialHold }, get StatesEnum() { return StatesEnum }, get calculateStateFromPostcode() { return calculateStateFromPostcode } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})